import { medias } from '@/utils/sizes';
import { generateClampFromMax } from '@/utils/styling';
import styled, { css } from 'styled-components';

export const MainText = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isContentTwoColumns'].includes(prop),
})<{
  isContentTwoColumns: boolean;
}>`
  &.reduced-width {
    width: 80%;
  }

  h1[data-inline-title] {
    display: contents;
    font-size: unset !important;
    font-weight: unset !important;
  }

  .custom-link {
    color: currentColor;
    display: block;
    margin-top: var(--spacing-component-inner-lg);
    margin-bottom: 10px;

    ${medias.max.mobile} {
      color: var(--c-font-secondary);
    }
  }

  ${medias.min.tablet} {
    .subtitle {
      padding-right: 10%; 
    }
  }

  ${({ isContentTwoColumns }) =>
    isContentTwoColumns
      ? css`
          display: grid;
          grid-template-columns: 1.1fr 0.9fr;
          grid-gap: var(--spacing-component-inner);

          ${medias.min.tablet} {
            grid-column-gap: ${generateClampFromMax(69)};
            /* grid-column-gap: var(--spacing-component-inner); */
          }

          ${medias.max.mobile} {
            grid-template-columns: 1fr;
            grid-gap: var(--spacing-component-inner-lg);
            padding-top: var(--spacing-component-inner-lg);
          }
        `
      : css`
          display: flex;
          flex-direction: column;
          gap: var(--spacing-component-inner);

          ${medias.max.tablet} {
            gap: var(--spacing-component-inner-lg);
            padding-top: var(--spacing-component-inner-lg);
          }
        `}

  ${medias.max.mobile} {
    .empty-side {
      display: none;
    }

    .custom-link {
      margin-top: 0;
      margin-bottom: 0;
    }

    p {
      span {
        display: inline-block;
      }
    }

    *[data-animation='revealUp'] {
      span {
        /* opacity: 0; */
        /* display: inline-block; 
      clip-path: inset(100% 0 0 0); 
      transition: clip-path 0.5s ease-out;  */
      }

      ${medias.max.mobile} {
        span {
          display: inline;
        }
      }
    }
  }
`;

export const CounterCountainer = styled.div`
  margin-top: var(--spacing-component-inner-sm);
`;
